import { AxiosResponse } from "axios";
import ApiService from "./ApiService";
const CryptoJS = require("crypto-js");

export default class UserService {
  public static async login(data: any): Promise<AxiosResponse<any, any>> {
    return await ApiService.post("/authentication/LoginWithEmailandPassword", {
      Email: data.userName,
      Password: CryptoJS.SHA256(data.password).toString(),
    });
  }

  public static async register(
    email: string,
    password: string,
    firstName: string,
    LastName: string,
    phone: string,
    wayToKnow: string
  ): Promise<AxiosResponse<any, any>> {
    return await ApiService.post("/authentication/register", {
      Email: email,
      Password: CryptoJS.SHA256(password).toString(),
      FirstName: firstName,
      LastName,
      Phone: phone,
      Role: "Teammember",
      WayToKnow: wayToKnow,
    });
  }
  public static resetPassword(email: string, callbackUrl: string): Promise<void> {
    return new Promise((resolve, reject) => {
      ApiService.post("/authentication/ForgotPassword", { email: email, callbackUrl: callbackUrl })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static validateResetToken(token: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.post("/authentication/ValidateResetToken", { token: token })
        .then((result) => {
          resolve(result.data.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  public static saveNewPassword(password: string, token: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.post("/authentication/ResetPassword", { password: CryptoJS.SHA256(password).toString(), token: token })
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
